export const CONDITIONS = [
  { label: '>', value: 'isGreater', showValue: true },
  { label: '<', value: 'isLess', showValue: true },
  { label: '>=', value: 'isGreaterOrEqual', showValue: true },
  { label: '<=', value: 'isLessOrEqual', showValue: true },
]
